package lacaravana.ui

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.dom.append
import lacaravana.app.Database
import lacaravana.domain.Menu

object CartaView {
    suspend fun render(db: Database) {
        val content = document.getElementById("content") ?: return
        content.innerHTML = ""
        val items = Menu.available(db)
        val byCategory = items.groupBy { it.categoria }
        val categoryOrder = listOf("entrante", "principal", "postre", "bebida")

        content.append {
            div("carta") {
                div("carta-header") {
                    h1 { +"La Caravana" }
                    p("carta-subtitle") { +"Carta" }
                }
                for (cat in categoryOrder) {
                    val catItems = byCategory[cat] ?: continue
                    div("carta-section") {
                        h2("carta-category") { +cat.replaceFirstChar { it.uppercase() } }
                        for (item in catItems) {
                            div("carta-item") {
                                span("carta-name") { +item.nombre }
                                span("carta-dots") {}
                                span("carta-price") { +Menu.formatPrice(item.precioCents) }
                            }
                        }
                    }
                }
            }
        }
    }
}
